/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ModuleFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    label?: boolean;
    icon?: boolean;
    routerLink?: boolean;
    code?: boolean;
    parentId?: boolean;
    order?: boolean;
    showInMenu?: boolean;
    external?: boolean;
    isNew?: boolean;
    platforms?: boolean;
    isEnabled?: boolean;
    mobileRoute?: boolean;
    navSlot?: boolean;
    navOrder?: boolean;
}

